/* eslint-disable prettier/prettier */
import { CityPath } from '../domain/CityPath';
import { CitySetting } from '../domain/CitySetting';
import { CityRepository } from '../infrastructure/CityRepository';

export class CityService {
    constructor() {
        this.repository = new CityRepository();
    }

    async getCityPaths() {
        try {
            const pathsData = await this.repository.fetchCityPaths();
            return pathsData.map(item => {
                const [path, region] = item.slice(1).split('-');
                return new CityPath(path, region);
            });
        } catch (error) {
            console.error('Error in CityService.getCityPaths:', error);
            throw error;
        }
    }

    async getCitySettings() {
        try {
            const data = await this.repository.fetchCitySettings();


            // 處理空陣列或 null 的情況
            if (!data || !Array.isArray(data) || data.length === 0) {
                console.warn('No city settings data available');
                return [];
            }

            return data.map(setting => new CitySetting(setting));
        } catch (error) {
            console.error('Error in CityService.getCitySettings:', error);
            throw error;
        }
    }
}
